import { render } from "./sf-progress-total-percentage.vue?vue&type=template&id=31bb135b&scoped=true"
import script from "./sf-progress-total-percentage.vue?vue&type=script&lang=js"
export * from "./sf-progress-total-percentage.vue?vue&type=script&lang=js"

import "./sf-progress-total-percentage.vue?vue&type=style&index=0&id=31bb135b&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31bb135b"]])

export default __exports__